<template>
  <div>
    <agile-table
    :data-type="'contacts'"
    :data="contacts"
    :table-meta="tableMeta"
    :filter-meta="filterMeta"
    :action-meta="actionMeta"
    :column-meta="columnMeta"
    @rowAction="rowAction"
    @fieldAction="fieldAction"
    @tableAction="tableAction" />
    <new-button @clicked="openContactModal" />
    <slideout-panel />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import NewButton from '@/components/actions/CreateNewButton'
import AgileTable from '@/components/table/AgileTable'
import ContactModal from '@/components/modals/ContactModal'
import saveAs from 'file-saver'

export default {
  components: {
    NewButton,
    AgileTable,
    saveAs
  },
  data () {
    return {
      debounceDelay: process.env.DEBOUNCE_DELAY,

      filterMeta: [],

      tableMeta: {
        heading: this.$route.params.projectId ? 'Projektpersoner' : 'Personer',
        headingIcon: 'fa-id-card',
        actions: [{
          label: 'Adresser',
          action: 'goToAddresses',
          iconClass: 'fal fa-address-card'
        }]
      },

      columnMeta: {
        hasActions: true,
        items: [{
          fieldId: 'firstName',
          label: 'Förnamn'
        },
        {
          fieldId: 'lastName',
          label: 'Efternamn'
        },
        {
          fieldId: 'freeText',
          label: 'Företag'
        },
        {
          fieldId: 'role',
          label: 'Roll'
        },
        {
          fieldId: 'email',
          label: 'E-post'
        },
        {
          fieldId: 'mobilePhone',
          label: 'Mobilnummer'
        },
        {
          fieldId: 'phone',
          label: 'Direktnummer'
        }]
      },
      actionMeta: {
        type: 'buttons',
        items: [{
          label: 'Ändra',
          action: 'updateContact',
          iconClass: 'fal fa-pen'
        }, {
          label: 'Export',
          action: 'exportContact',
          iconClass: 'fal fa-download'
        }, {
          label: 'Radera',
          action: 'deleteContact',
          iconClass: 'fal fa-trash-alt'
        }]
      }
    }
  },

  watch: {
    'contacts.filter': {
      handler () {
        this.$store.state.contacts.all.currentPage = 1
        this.getListData()
      },
      deep: true
    },
    '$route': 'routeUpdate'
  },

  computed: {
    ...mapState({
      contacts: state => state.contacts.all
    })
  },
  beforeMount () {
    this.routeUpdate()
  },

  methods: {
    ...mapActions('contacts', ['initialize', 'getListData', 'delete', 'downloadPersonAsCsv']),

    rowAction (action, contact) {
      switch (action) {
        case 'updateContact':
          this.openContactModal(contact.contactId)
          break

        case 'exportContact':
          this.exportContact(contact)
          break

        case 'deleteContact':
          this.deleteContact(contact)
          break

        default:
          this.$alert(action + ' is not defined!')
          break
      }
    },

    routeUpdate () {
      if (this.$route.params.projectId) {
        this.filterMeta = []
        this.contacts.filter = {
          projectId: this.$route.params.projectId
        }
      } else {
        this.filterMeta = [{
          fieldId: 'firstName',
          type: 'string',
          label: 'Förnamn'
        },
        {
          fieldId: 'lastName',
          type: 'string',
          label: 'Efternamn'
        },
        {
          fieldId: 'freeText',
          type: 'string',
          label: 'Företag'
        },
        {
          fieldId: 'role',
          type: 'string',
          label: 'Roll'
        },
        {
          fieldId: 'email',
          type: 'string',
          label: 'E-post'
        },
        {
          fieldId: null,
          type: 'empty-block'
        },
        {
          fieldId: 'mobilePhone',
          type: 'string',
          label: 'Mobilnummer'
        },
        {
          fieldId: 'phone',
          type: 'string',
          label: 'Direktnummer'
        },
        {
          fieldId: 'projectCode',
          type: 'string',
          label: 'Delaktig i projekt'
        },
        {
          fieldId: null,
          type: 'empty-block'
        }]
      }
    },
    fieldAction (action, contact) {
      switch (action) {
        default:
          this.$alert(action + ' is not defined')
          break
      }
    },
    tableAction (action) {
      switch (action) {
        case 'goToAddresses':
          if (this.$route.params.projectId) {
            this.$router.push({ name: 'Contacts_Addresses_Project', params: { projectId: this.$route.params.projectId } })
          } else {
            this.$router.push({ name: 'Contacts_Addresses' })
          }
          break
      }
    },
    openContactModal (id) {
      this.$panel(ContactModal, { id })
    },
    exportContact (contact) {
      this.downloadPersonAsCsv(contact.contactId)
    },
    deleteContact (contact) {
      let firstName = contact.firstName ? contact.firstName : ''
      let lastName = contact.lastName ? contact.lastName : ''

      this.$confirm('Radera personen', 'Är du säker på att du vill radera ' + firstName + ' ' + lastName + '?').then((result) => {
        if (result.value) {
          this.delete(contact.contactId)
        }
      })
    }
  },
  created () {
    this.initialize()
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/Admin/Contacts/PersonsPage.vue